// Build-time constants injected by Vite (see vite.config.ts).
export const APP_VERSION = __APP_VERSION__;
export const APP_COMMIT = __APP_COMMIT__;
export const APP_BUILD_TIME = __APP_BUILD_TIME__;

export const VERSION_LABEL = `v${APP_VERSION} · ${APP_COMMIT}`;

export function buildDiagnostics(extra?: Record<string, string>): string {
  const lines = [
    `Pebble Beta`,
    `Version: ${APP_VERSION}`,
    `Build: ${APP_COMMIT}`,
    `Built: ${APP_BUILD_TIME}`,
  ];
  if (extra) {
    for (const [k, v] of Object.entries(extra)) lines.push(`${k}: ${v}`);
  }
  if (typeof navigator !== 'undefined') lines.push(`UA: ${navigator.userAgent}`);
  return lines.join('\n');
}
